import { Box, CircularProgress, SxProps } from '@mui/material';
import { CircularProgressProps } from '@mui/material/CircularProgress/CircularProgress';
import * as React from 'react';
import { ReactNode } from 'react';

import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

type PropsType = {
  sx?: SxProps;
  children?: ReactNode;
  CircularProgressProps?: CircularProgressProps;
};

export const LoadingView = (props: PropsType) => {
  const { sx, children, CircularProgressProps } = props;
  const sxStyles = useSxStyles();

  return (
    <Box sx={mergeSxProps(sxStyles.loading, sx)}>
      <Box sx={sxStyles.loader}>
        <CircularProgress {...CircularProgressProps} />
      </Box>
      {!!children && <Box sx={sxStyles.loaderMessage}>{children}</Box>}
    </Box>
  );
};
